export default __webpack_public_path__ + "static/media/Capturar.ad601c5d.PNG";